<div [formGroup]="form">
  <ng-container
    [formGroupName]="i"
    *ngFor="let ise of form?.controls; let i = index">
    <div class="ise-container-fields">
      <mat-form-field>
        <input
          matInput
          placeholder="Riferimento alla parte (ISER)"
          formControlName="ISER">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Posizione (ISEP)"
          formControlName="ISEP">
      </mat-form-field>
      <app-input-vocabulary-autocomplete
        formControlName="ISED"
        [vocabularyName]="'V_F_ISED'"
        [placeholder]="'Definizione (ISED)'">
      </app-input-vocabulary-autocomplete>
      <mat-form-field>
        <input
          matInput
          placeholder="Specifiche (ISEE)"
          formControlName="ISEE">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Descrizione (ISEZ)"
          formControlName="ISEZ">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Quantità (ISEQ)"
          formControlName="ISEQ">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Supporto (ISES)"
          formControlName="ISES">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Classe di appartenenza (ISEC)"
          formControlName="ISEC">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Lingua (ISEL)"
          formControlName="ISEL">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Alfabeto (ISEF)"
          formControlName="ISEF">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Tipo di caratteri (ISET)"
          formControlName="ISET">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Materia e tecnica (ISEM)"
          formControlName="ISEM">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Trascrizione (ISEI)"
          formControlName="ISEI">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Autore (ISEA)"
          formControlName="ISEA">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Identificazione (ISEO)"
          formControlName="ISEO">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Trascrizione (ISEI)"
          formControlName="ISEI">
      </mat-form-field>
      <mat-form-field>
        <input
          matInput
          placeholder="Note (ISEN)"
          formControlName="ISEN">
      </mat-form-field>
    </div>
    <div class="ise-container-actions">
      <button
        mat-raised-button
        type="button"
        (click)="removeHandler(i)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </ng-container>
  <button
    mat-raised-button
    type="button"
    (click)="addHandler()">
    {{ 'Aggiungi iscrizione' | translate }}
  </button>
</div>
